import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import HomePage from '@/components/HomePage'
import UnAuthenticated from '@/components/UnAuthen'
import PerfDesign from '@/components/PerfDesign'
import PerfScore from '@/components/PerfScore'
import PerfScorePage from '@/components/PerfScorePage'
import PerfSum from '@/components/PerfSum'
import PerfSumPage from '@/components/PerfSumPage'
import SysConfig from '@/components/SysConfig'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: '简单绩效',
        component: HomePage
    },
    {
        path: '/unauthen',
        name: 'UnAuthenticated',
        component: UnAuthenticated
    },
    {
        path: '/perfdesign',
        name: '绩效考核目标',
        component: PerfDesign,
        props:true
    },
    {
        path: '/perfscorepage/:year/:month',
        name: '绩效考核打分',
        component: PerfScorePage,
        props: (route) => ({
            year: parseInt(route.params.year),
            month: parseInt(route.params.month)
        })
    },
    {
        path: '/perfscore',
        name: '绩效考核打分',
        component: PerfScore
    },
    {
        path: '/perfsum',
        name: '绩效考核成绩',
        component: PerfSum
    },
    {
        path: '/perfsumpage/:year/:month',
        name: '绩效考核成绩',
        component: PerfSumPage,
        props: (route) => ({
            year: parseInt(route.params.year),
            month: parseInt(route.params.month)
        })
    },
    {
        path: '/sysconfig',
        name: '系统管理',
        component: SysConfig
    }
]


const router = new VueRouter({
    routes
  })

router.beforeEach((to, from, next) => {
    (store.state.cur_user || to.path === '/unauthen') ? next() : next('/unauthen')
})

export default router